<template>
    <div class="no-xhide">
        <v-snackbar class="snakbar-sty pt-6 d-md-none pr-6 z-i6 rounded-pill" transition="slide-x-reverse-transition"
            v-model="snackbar" timeout="4000" :value="true" :color="snackbarclr" absolute text-color="white">
            <v-icon class="mr-2" color="#fff">mdi-alert-outline</v-icon>
            {{ snackmsgbar }}
            <v-icon @click="snackbar = false" class="float-right" color="#fff">mdi-close-circle</v-icon>
        </v-snackbar>
        <v-snackbar class="snakbar-sty d-none d-md-flex pt-6 pr-6 z-i6 rounded-pill mt-10"
            transition="slide-x-reverse-transition" top right v-model="snackbar" timeout="4000" :value="true"
            :color="snackbarclr" absolute text-color="white">
            <v-icon class="mr-2" color="#fff">mdi-alert-outline</v-icon>
            {{ snackmsgbar }}
            <v-icon @click="snackbar = false" class="float-right" color="#fff">mdi-close-circle</v-icon>
        </v-snackbar>
        <div data-aos="fade-up" class="pt-md-6">
            <v-card class="elevation-0 px-16 py-10 rounded-xl pos-rlt d-none d-md-block" color="#E5EBEC">
                <p class="fs-50 font-weight-bold mb-0"> Webinars</p>
                <p class="headline">Intriguing webinars for the investor in you. <br> Easy to understand videos to help
                    with everyday.

                </p>

                <!-- {{ allvideos }} -->

                <v-autocomplete @change="videoShow(b = videois)" item-text="attributes.Title" item-value="Title"
                    append-icon="" :items="allvideos" :disabled="isLoading" :loading="isLoading" v-model="videois" block
                    flat solo background-color="#ffffff" clearable return-object
                    class="search-field elevation-0 mr-3 rounded-pill caption" label="Search videos" hide-details>
                    <template #prepend-inner>
                        <img src="@/assets/search-icon.svg" width="100%" class="mx-2" alt="search-icon">
                    </template>
                </v-autocomplete>

                <div>
                    <img class="pos-abs calc-img text-right" alt="main-bg.png" src="@/assets/Video/main-bg-web.svg"
                        width="30%" />
                </div>
                <div class="pos-abs learn-img">
                    <img alt="learn-bg.svg" src="@/assets/learn-bg.svg" width="172px" />
                </div>
            </v-card>
            <v-card class="elevation-0 px-6 px-sm-8 py-10 rounded-0 text-center d-md-none" color="#E5EBEC">
                <p class="fs-38 font-weight-bold">Webinars</p>
                <p class="fs-18 mb-8">Intriguing webinars for the investor in you. <br> Easy to understand videos to
                    help with
                    everyday.
                </p>

                <v-autocomplete @change="videoShow(b = videois)" item-text="attributes.Title" item-value="videoid"
                    append-icon="" :items="allvideos" :disabled="isLoading" :loading="isLoading" v-model="videois" block
                    flat solo background-color="#ffffff" clearable return-object
                    class="elevation-0 rounded-pill caption" label="Search videos" hide-details>
                    <template #prepend-inner>
                        <img src="@/assets/search-icon.svg" width="100%" class="mx-2" alt="search-icon">
                    </template>
                </v-autocomplete>
            </v-card>
        </div>
        <!-- <div class="mt-14">
            <v-toolbar dense class="elevation-0 mb-6 d-none d-md-block">
                <div>
                    <p class="mb-0 font-weight-bold secondary-infont fs-32 lh-32">Upcoming webinars</p>
                    <p class="mb-0 title font-weight-regular">Have questions? Our team is here to provide answers.<br> Join
                        our 
                        upcoming webinar to interact directly with us!
                        .</p>
                </div>
                <v-spacer></v-spacer>
                <v-btn to="/upcomingwebinar" color="#0037B7" text class="text-capitalize"><span
                        class="font-weight-medium">View
                        all Upcoming webinars</span></v-btn>

            </v-toolbar>
            <v-toolbar dense class="elevation-0 mb-6 d-md-none">
                <div class="pl-2 pl-sm-4">
                    <p class="mb-0 font-weight-bold secondary-infont fs-28">Upcoming webinars</p>
                    <p class="mb-0 fs-16 font-weight-regular">Have questions? Our team is here to provide answers.<br> Join
                        our<br>
                        upcoming webinar to interact directly with us!
                        .</p>
                </div>

            </v-toolbar>
        </div> -->
        <!-- <div class=" pb-14">
            <div class=" text-centre" v-if="isLoading">
                <v-container fill-height>
                    <v-card class="elevation-0 mx-auto my-16">
                        <v-progress-circular size="80" indeterminate color="#1e53e5"></v-progress-circular>
                    </v-card>
                </v-container>
            </div>
            <div v-if="allvideos != ''">
                <v-row>
                    <v-col cols="12" sm="4" xl="3" lg="4" v-for="(item, index) in allvideos.slice(0, 8)" :key="index">
                        <v-card elevation="0" class="pa-4 hcard" v-if="item.attributes.webinortype == 'upcoming'">
                            <v-card @click="singleBlog(item)" elevation="0">
                                <v-img :src="item.attributes.img" width="100%" height="100%" cover></v-img>
                            </v-card>
                            <v-list-item data-aos="fade-left" class="px-0">
                                <v-list-item-content @click="singleBlog(item)" class="pt-1">
                                    <v-list-item-title class="font-weight-bold subtitle-1 mt-3 text-rap-l2">{{
                                        item.attributes.Title
                                        }}</v-list-item-title>
                                 
                                    <p class="mb-0  font-weight-regular subtitle-2"> <span
                                            class="mb-0  font-weight-regular subtitle-2">Webinar Date : {{
                                                item.attributes.Event_date }}</span></p>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-btn small outlined elevation="0" class="text-none" rounded target="_blank"
                                        :href="item.attributes ? item.attributes.webinar_Link : ''"
                                        color="black">Register</v-btn>
                                </v-list-item-action>
                            </v-list-item>

                        </v-card>
                    </v-col>
                </v-row>
                <div class="text-center mt-4 ">

                    <v-btn to="/upcomingwebinar" v-if="allvideos.length > 6" color="#0037B7" text
                        class="text-capitalize"><span class="font-weight-medium">View all Upcoming
                            webinars</span></v-btn>

                </div>
            </div>
            <div v-else>
                <div class="mx-auto pa-16 text-center" v-if="allvideos == '' && isLoading == false">

                    <p class="txt-000 font-weight-bold mb-2 title">Don’t miss out our next webinar </p>
                    <v-btn rounded  color="#212424" style="width: 700px;" class="white--text text-none mt-4" elevation="0">Coming
                        soon....
                    </v-btn>
                </div>
            </div>
        </div> -->

        <div class="pt-3">
            <v-toolbar dense class="elevation-0 mt-14 d-none d-md-block">
                <div>
                    <p class="mb-0 font-weight-bold secondary-infont fs-32 lh-32">Learn From Industry Experts </p>
                    <p class="mb-0 title font-weight-regular">From Charts to Choices — Learn to Trade, Invest, and Grow
                        Wealth.
                    </p>
                </div>
                <v-spacer></v-spacer>
                <!-- <v-btn to="/closewebinar" color="#0037B7" text class="text-capitalize"><span
                        class="font-weight-medium">View all
                    </span></v-btn> -->
            </v-toolbar>
            <v-toolbar dense class="elevation-0 mb-6 d-md-none">
                <div class="pl-2 pl-sm-4">
                    <p class="mb-0 font-weight-bold secondary-infont fs-28">Learn From Industry Experts </p>
                    <p class="mb-0 fs-16 font-weight-regular">From Charts to Choices — Learn to Trade, Invest, and Grow
                        Wealth.
                    </p>
                </div>
            </v-toolbar>
        </div>

        <div class=" pb-14">
            <div class=" text-centre" v-if="isLoading">
                <v-container fill-height>
                    <v-card class="elevation-0 mx-auto my-16">
                        <v-progress-circular size="80" indeterminate color="#1e53e5"></v-progress-circular>
                    </v-card>
                </v-container>
            </div>
            <div class="mt-4" v-if="allvideosclosed != ''">
                <v-row>
                    <v-col cols="12" sm="4" xl="3" lg="4" v-for="(item, index) in visibleVideos" :key="index">
                        <v-card elevation="0" class="pa-4 hcard">
                            <v-card @click="singleBlog(item)" elevation="0">
                                <v-img :src="item.attributes.img" width="100%" height="100%" cover></v-img>
                            </v-card>
                            <v-list-item data-aos="fade-left" class="px-0">
                                <v-list-item-content @click="singleBlog(item)" class="pt-1">
                                    <v-list-item-title class="font-weight-bold subtitle-1 mt-3 text-rap-l2">{{
                                        item.attributes.Title
                                        }}</v-list-item-title>

                                          
                                    <p class="mb-0  font-weight-regular subtitle-2"> 
                                        <span>  <div  v-if="item.attributes.webinortype == 'upcoming'" class="mr-3 blinking-dot"></div></span>
      <v-chip class="captionfont-weight-semibold  mr-3" small :style="{'background-color' : item.attributes.webinortype == 'upcoming' ? '#E3EEE8' : '#F3D8DA', 'border' : item.attributes.webinortype == 'upcoming' ?  '1px solid green' : '1px solid red' , 'color' : item.attributes.webinortype == 'upcoming' ?  'green' : 'red'}">{{ item.attributes.webinortype == 'upcoming' ?'Upcoming' : 'Closed'  }}</v-chip>
                                        
                                        <span
                                            v-if="item.attributes.webinortype == 'upcoming'">Webinar Date: </span>{{
                                                item.attributes.Event_date.split('-').reverse().join('-') }}
                                        <span v-if="item.attributes.webinortype != 'upcoming'"> ({{ item.ago }})</span>
                                        <span v-if="item.attributes.webinortype == 'upcoming'">

                                            <!-- <span v-if="item.attributes.webinortype == 'upcoming'"
                                                class="caption font-weight-bold ml-1"
                                                style="color:#3CA261">Upcoming</span> -->
                                        </span>
                                        <!-- <span v-if="item.attributes.webinortype != 'upcoming'"
                                            class="caption font-weight-bold ml-1" style="color:#F23645">Closed</span> -->
                                    </p>
                                </v-list-item-content>
                                <v-list-item-action v-if="item.attributes.webinortype == 'upcoming'">
                                    <v-btn small outlined elevation="0" class="text-none" rounded target="_blank"
                                        :href="item.attributes ? item.attributes.webinar_Link : ''"
                                        color="black">Register</v-btn>
                                </v-list-item-action>

                            </v-list-item>

                        </v-card>
                    </v-col>
                </v-row>


                <div class="text-center mt-4 " v-if="visibleVideos.length > 7">
                    <v-btn v-if="visibleCount < allvideosclosed.length" color="primary" class="pl-7 pr-7 text-none" rounded
                        elevation="0" @click="visibleCount += 8">
                      View More  <v-icon class="ml-3">mdi-chevron-down</v-icon>
                    </v-btn>

                    <v-btn elevation="0" class="text-none pl-7 pr-7" rounded v-else-if="visibleCount >= allvideosclosed.length"
                        color="primary" @click="visibleCount = 8">
                 View Less      <v-icon class="ml-3">mdi-chevron-up</v-icon> 
                    </v-btn>


                </div>
            </div>
            <div v-else>
                <div class="mx-auto pa-16 text-center" v-if="allvideosclosed == '' && isLoading == false">
                    <img class="align-self-stretch mx-auto" width="100px"
                        :src="require('@/assets/no data folder.svg')" />
                    <h4 class="txt-999 font-weight-regular">There is no data here yet!</h4>
                </div>
            </div>
        </div>

        <div class="mb-16">
            <v-card width="100%" class="price-card-sty text-centre elevation-0 rounded-xl py-6 px-8 d-none d-md-block">
                <v-row>
                    <v-col cols="4">
                        <p class="mb-0 font-weight-bold secondary-infont mb-4 fs-24">Don’t miss out our next webinar
                        </p>
                         <p class="mb-0 font-weight-bold  mb-2 fs-20">Reserve Your Free Spot Today!
                        </p>
                        <p class="mb-2 font-weight-regular">Enter your email and phone number to get instant access to
                            our
                            upcoming webinar – it’s quick, easy, and completely free.</p>
                    </v-col>
                    <v-col cols="8">

                        <div class="d-flex mt-7">
                            <v-text-field flat solo background-color="#ffffff" outlined hide-details
                                v-model="marketemail"
                                class="menu-field-num elevation-0 mr-3 rounded-pill caption my-auto ml-16"
                                label="Enter your Mobile No" required
                                :rules="[v => !!v || 'Mobile No is required', v => /^[\w\.-]+@[\w\.-]+\.\w+$/.test(v) || 'E-mail must be valid']">
                                <template #prepend-inner>
                                    <img src="@/assets/contactus/phone.svg" width="100%" class="mx-2" alt="phone-icon">
                                </template>
                            </v-text-field>

                            <v-text-field flat solo background-color="#ffffff" outlined hide-details
                                v-model="marketmobile"
                                class="menu-field-num elevation-0 mr-3 rounded-pill caption my-auto "
                                label="Enter your email" required
                                :rules="[v => !!v || 'E-mail is required', v => /^[\w\.-]+@[\w\.-]+\.\w+$/.test(v) || 'E-mail must be valid']">
                                <template #prepend-inner>
                                    <img src="@/assets/mail-icon.svg" width="100%" class="mx-2" alt="mail-icon">
                                </template>

                            </v-text-field>
                            <v-btn :loading="webloading" large @click="webinardata()"
                                :disabled="marketemail == '' || marketmobile == ''"
                                class="text-none elevation-0 mt-2 white--text" rounded color="black">Book a Slot</v-btn>

                        </div>
                    </v-col>


                </v-row>
            </v-card>
            <v-card width="100%" class="price-card-sty elevation-0 rounded-xl py-6 px-6 px-sm-8 d-md-none">
                <v-row>
                    <v-col cols="12" md="5">
                        <p class="font-weight-bold secondary-infont mb-2 fs-24">Reserve Your Free Spot Today!
                        </p>
                        <p class="mb-2 fs-16 font-weight-regular">Enter your email and phone number to get instant
                            access to
                            our
                            upcoming webinar – it’s quick, easy, and completely free.</p>
                    </v-col>
                    <v-col cols="12" md="7" class="pa-0 pa-md-3">

                        <v-text-field flat solo background-color="#ffffff" outlined hide-details v-model="marketemail"
                            class="menu-field-num elevation-0 mr-3 rounded-pill caption my-auto "
                            label="Enter your Mobile No" required
                            :rules="[v => !!v || 'Mobile No is required', v => /^[\w\.-]+@[\w\.-]+\.\w+$/.test(v) || 'E-mail must be valid']">
                            <template #prepend-inner>
                                <img src="@/assets/contactus/phone.svg" width="100%" class="mx-2" alt="phone-icon">
                            </template>
                        </v-text-field>

                        <v-text-field flat solo background-color="#ffffff" outlined hide-details v-model="marketmobile"
                            class="menu-field-num elevation-0 mr-3 mt-5 rounded-pill caption my-auto "
                            label="Enter your email" required
                            :rules="[v => !!v || 'E-mail is required', v => /^[\w\.-]+@[\w\.-]+\.\w+$/.test(v) || 'E-mail must be valid']">
                            <template #prepend-inner>
                                <img src="@/assets/mail-icon.svg" width="100%" class="mx-2" alt="mail-icon">
                            </template>

                        </v-text-field>
                        <v-btn :loading="webloading" large @click="webinardata()"
                            :disabled="marketemail == '' || marketmobile == ''"
                            class="text-none elevation-0 mt-5  white--text" block rounded color="black">Book a
                            Slot</v-btn>

                    </v-col>
                </v-row>
            </v-card>
        </div>


        <div class="px-6 px-sm-8 px-md-0 mb-15">
            <v-card width="100%" data-aos="fade-down" color="#E5EBEC"
                class="box-s1 elevation-0 rounded-xl pt-8 pb-10 d-none d-md-block" outlined>
                <div class="pos-rlt">
                    <p class="mb-0 fs-24 text-center black--text font-weight-medium">Frequently Asked Questions</p>

                    <p class="font-weight-light text-center mt-2 black--text fs-18">Questions on your mind? Don't worry
                        we have
                        the
                        answers!</p>

                    <v-expansion-panels dense v-model="panelselecte"
                        class="elevation-0 rounded-0 pl-8 mt-2 pr-8 mb-md-0">
                        <v-expansion-panel class="bgstyle" v-for="(p, h) in onlinepay" :key="h">
                            <v-expansion-panel-header @click="setScrollwindow()"
                                class="font-weight-bold bgstyle py-0 ml-md-0">
                                <span class="fs-18">{{ h + 1 }}. {{ p.attributes.question }}</span>
                                <template v-slot:actions>
                                    <v-icon class="d-none d-md-block">mdi-chevron-down</v-icon>
                                    <v-icon class="d-md-none">mdi-chevron-down</v-icon>
                                </template>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content class="bgstyle">
                                <p class="mb-0 ml-5 fs-17 font-weight-light" v-html="p.attributes.answer"></p>
                            </v-expansion-panel-content>
                            <v-divider></v-divider>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </div>
            </v-card>
        </div>

        <div class="d-md-none pb-6">
            <p class="mb-0 fs-24 ml-8 black--text font-weight-medium">Frequently Asked Questions</p>

            <p class="font-weight-light ml-8 mt-3 black--text fs-17">Questions on your mind? Don't worry we have the
                answers!
            </p>
            <v-expansion-panels dense v-model="panelselecte" class="elevation-0 rounded-0 mb-6 ml-3 mb-md-0">
                <v-expansion-panel class="exp-sty" v-for="(p, h) in onlinepay" :key="h">
                    <v-expansion-panel-header @click="setScrollwindow()"
                        class="font-weight-bold subtitle-1 py-0 ml-md-3">{{ h +
                            1
                        }}.
                        {{ p.attributes.question }}
                        <template v-slot:actions>
                            <v-icon class="d-none d-md-block"></v-icon>
                            <v-icon class="d-md-none">mdi-chevron-down</v-icon>
                        </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <p class="mb-0 font-weight-light" v-html="p.attributes.answer"></p>
                    </v-expansion-panel-content>
                    <v-divider></v-divider>
                </v-expansion-panel>
            </v-expansion-panels>
        </div>

        <v-dialog v-model="videodialog" class="elevation-0 my-0" content-class="elevation-0">
            <v-container class="pa-md-0" fill-height>
                <v-card color="transparent" class="video-frame rounded-md mx-0 mx-md-auto elevation-0 pb-0 mb-0">
                    <v-toolbar color="transparent" dense class="tool-dialog elevation-0">
                        <div>
                            <v-list-item class="pl-0 d-none d-md-block">
                                <v-list-item-content class="pt-1">
                                    <v-list-item-title class="font-weight-bold title white--text">{{ playvideo ?
                                        playvideo.attributes.Title : null }}</v-list-item-title>
                                    <p class="mb-0 white--text"> <v-icon color="#fff"
                                            size="8">mdi-checkbox-blank-circle</v-icon> {{ playvideo ?
                                                playvideo.ago : null }}</p>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item class="pl-0 d-md-none">
                                <v-list-item-content class="pt-1">
                                    <v-list-item-title class="font-weight-bold fs-14 white--text">{{ playvideo ?
                                        playvideo.attributes.Title : null }}</v-list-item-title>
                                    <p class="mb-0 white--text fs-12">
                                        <v-icon color="#fff" size="8">mdi-checkbox-blank-circle</v-icon> {{ playvideo ?
                                            playvideo.ago : null }}
                                    </p>
                                </v-list-item-content>
                            </v-list-item>
                        </div>
                        <v-spacer></v-spacer>
                        <v-icon @click="videoClose()" color="#ffffff">mdi-close</v-icon>
                    </v-toolbar>
                    <div>
                        <iframe class="rounded-lg video-dialog" type="text/html"
                            :src="`${playvideo ? convertToEmbed(playvideo.attributes.webinar_Link) : ''}`"
                            frameborder="0"
                            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>

                    </div>
                    <!-- vjhvjhv {{ playvideo ? convertToEmbed(playvideo.attributes.webinar_Link) : "" }} -->
                    <div class="pos-abs z-in1 trans-cent abs-post4">
                        <v-progress-circular v-if="videodialog" size="80" :width="4" indeterminate
                            color="#ffffff"></v-progress-circular>
                    </div>
                </v-card>
            </v-container>
        </v-dialog>

    </div>
</template>


<script>
import axios from "axios";
// import { sessapi } from '../../apiurl'
import { ipolpdatastore } from "../../apiurl";

export default {
    data: () => ({
        playvideo: null,
        videodialog: false,
        page: 1,
        allvideos: [],
        allvideosclosed: [],
        videois: null,
        isLoading: null,
        snackbar: false,
        snackbarclr: "#2a2a2a",
        snackmsgbar: "",
        panelselecte: "",
        onlinepay: [],
        marketmobile: "",
        marketemail: "",
        webloading: false,
        visibleCount: 8,
        // videodialog: false,
        // schoolload:true,
    }),
    mounted() {
        this.getVideos();
        this.ipofaqapi();
    },
    methods: {
        webinardata() {
            this.webloading = true
            const axios = require('axios');
            let data = JSON.stringify({
                "email": this.marketemail,
                "mobile": this.marketmobile
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: `${ipolpdatastore}/api/store`,
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    axiosThis.webloading = false
                    if (response.data.status == "ok") {
                        axiosThis.snackbar = true;
                        axiosThis.snackbarclr = "green";
                        axiosThis.snackmsgbar = "Thanks for registering! You're all set for the webinar.";
                        axiosThis.marketemail = ""
                        axiosThis.marketmobile = ""
                    } else {
                        axiosThis.snackbar = true;
                        axiosThis.snackbarclr = "red";
                        axiosThis.snackmsgbar = response.data;
                    }
                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.snackbar = true;
                    axiosThis.snackbarclr = "error";
                    axiosThis.webloading = false
                    axiosThis.snackmsgbar = error;
                });

        },
        ipofaqapi() {
            this.onlinepay = [];
            const axios = require("axios");

            let config = {
                method: "post",
                maxBodyLength: Infinity,
                url: "https://sess.mynt.in/strapi/webinarfaqs",
                headers: {},
            };
            var axiosThis = this;
            axios
                .request(config)
                .then((response) => {
                    // console.log(JSON.stringify(response.data));
                    axiosThis.onlinepay = response.data.data;
                })
                .catch((error) => {
                    console.log(error);
                    this.snackbar = true;
                    this.snackbarclr = "error";
                    this.snackmsgbar = error;
                });
        },
        videoClose() {
            this.videodialog = false;
            // console.log("typeof",typeof this.playvideo);

            // this.playvideo = {}; 
        },

        convertToEmbed(link) {
            // console.log("link", link);

            let videoId = '';

            if (link.includes('youtu.be/')) {
                videoId = link.split('youtu.be/')[1]?.split('?')[0];
            } else if (link.includes('youtube.com/watch')) {
                videoId = link.split('v=')[1]?.split('&')[0];
            }

            // console.log("videoId", videoId);

            return videoId ? `https://www.youtube.com/embed/${videoId}` : '';
        },

        videoShow(b) {
            if (b) {
                // b.attributes['pagename'] = this.pagename;
                // this.$router.push({ name: 'single blog', params: b });
                b.attributes['pagename'] = b;
                const formattedTitle = b.attributes.Title.replace(/\s+/g, '-').replace(/[^a-zA-Z0-9-]/g, '');
                this.$router.push(`/webinar/${formattedTitle}-${b.id}`);

            }
        },

        videoShowcol(item) {
            this.playvideo = item;
            this.videodialog = true;
        },
        getVideos() {
            this.isLoading = true;
            this.allvideos = []
            this.allvideosclosed = []
            let config = {
                method: 'post',
                url: `https://sess.mynt.in/strapi/zebu-schools?populate=*`,
            };

            let axiosThis = this;
            axios.request(config)
                .then((response) => {
                    axiosThis.isLoading = false;
                    if (response.data.data) {
                        let data = response.data.data;

                        let allWebinars = [];

                        for (let v = 0; v < data.length; v++) {
                            const item = data[v];
                            const attr = item.attributes;

                            // Common image URL
                            attr["img"] = `https://sess.mynt.in/strapi${attr.Image.data[0].attributes.url}`;

                            // Time ago calculation
                            item['ago'] = axiosThis.differentDate(attr.publishedAt);

                            allWebinars.push(item);
                        }

                        // Custom sort: 'upcoming' first, then 'Closed', and sort each by Event_date descending
                        allWebinars.sort((a, b) => {
                            const typeOrder = { "upcoming": 1, "Closed": 2 };
                            const typeA = typeOrder[a.attributes.webinortype] || 99;
                            const typeB = typeOrder[b.attributes.webinortype] || 99;

                            if (typeA !== typeB) {
                                return typeA - typeB; // Sort by type first
                            }

                            // If same type, sort by date descending
                            const dateA = new Date(a.attributes.Event_date);
                            const dateB = new Date(b.attributes.Event_date);
                            return dateB - dateA;
                        });

                        // Assign to single array
                        axiosThis.allvideosclosed = allWebinars;
                    }





                    // console.log(axiosThis.allvideos);

                    axiosThis.isLoading = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.isLoading = false;

                    this.snackbar = true;
                    this.snackbarclr = "error";
                    this.snackmsgbar = error;
                });
        },
        differentView(view) {
            return `${view > 999 ? Math.round(view / 1000) : view > 999999 ? Math.round(view / 1000000) : view > 999999999 ? Math.round(view / 1000000000) : view} ${view > 999 ? 'K' : view > 999999 ? 'M' : view > 999999999 ? 'B' : ''}`
        },
        differentDate(date) {
            var date1 = new Date(date);
            var date2 = new Date();
            var ov = Math.abs(date2.getTime() - date1.getTime())
            var mt = Math.round(ov / 3600000)
            var dd = mt > 60 ? Math.round(mt / 24) : 0;
            var mm = dd > 30.4166667 ? Math.round(dd / 30.4166667) : 0;
            var yy = mm > 12 ? Math.round(dd / 365) : 0;
            return `${yy != 0 ? yy : mm != 0 ? mm : dd != 0 ? dd : mt != 0 ? mt : 0} ${yy != 0 ? yy > 1 ? 'years' : 'year' : mm != 0 ? mm > 1 ? 'months' : 'month' : dd != 0 ? dd > 1 ? 'days' : 'day' : mt > 1 ? 'hours' : 'minutes'} ago`;
        },

        singleBlog(item, p) {


            item.attributes['pagename'] = p;
            const formattedTitle = item.attributes.Title.replace(/\s+/g, '-').replace(/[^a-zA-Z0-9-]/g, '');
            this.$router.push(`/webinar/${formattedTitle}-${item.id}`);

        },


    },
    computed: {
        visibleVideos() {
            return this.allvideosclosed.slice(0, this.visibleCount);
        }
    }

}
</script>
<style>
.blinking-dot {
    height: 10px;
    width: 10px;
    background-color: #3CA261;
    border-radius: 50%;
    display: inline-block;
    animation: blink 1s infinite;
}

@keyframes blink {
    0% {
        opacity: 1;
    }

    50% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}
</style>